import React from "react";
import type { AssignmentRowProps } from "./AssignmentList.types";
import * as S from "./AssignmentList.styles";

/** One value with its people: avatar and label, address chips with "+N", an add slot, and a status. */
export const AssignmentRow: React.FC<AssignmentRowProps> = ({ row, maxChips = 2, addSlot }) => {
  const shown = row.chips.slice(0, maxChips);
  const extra = row.chips.length - shown.length;
  const right = row.error ?? row.warning ?? row.statusLabel;
  return (
    <S.Row data-status={row.status} aria-current={row.status === "current" ? "true" : undefined}>
      <S.Who>
        {row.avatar && (
          <S.Avatar $color={row.avatar.color} aria-hidden="true">
            {row.avatar.imageUrl ? <img src={row.avatar.imageUrl} alt="" /> : row.avatar.initials}
          </S.Avatar>
        )}
        <S.Label title={row.label}>{row.label}</S.Label>
      </S.Who>
      <S.Chips>
        {shown.map((c) => (
          <S.Chip key={c.id} data-invalid={c.invalid ? "true" : undefined}>{c.label}</S.Chip>
        ))}
        {extra > 0 && <S.Chip>{`+${extra}`}</S.Chip>}
        {addSlot}
      </S.Chips>
      <S.Status data-error={row.error ? "true" : undefined} data-warning={!row.error && row.warning ? "true" : undefined}>
        {right}
      </S.Status>
    </S.Row>
  );
};

export default AssignmentRow;
